import type { EnglishTestQuestionDto } from '@/api/generated/models'
import type { QuestionAnswerValue } from './types'
import { EnglishTestQuestionDtoQuestionTypeEnum } from '@/api/generated/models'

export const ENGLISH_TEST_GROUP_SIZE = 4

const API_URL = import.meta.env.VITE_API_URL || 'https://api-qa.160digital.com'
const DATE_ENTRY_QUESTION_TYPE = 'DATE_ENTRY'
const TEXT_ENTRY_QUESTION_TYPE = 'TEXT_ENTRY'

export function byDisplayOrder<T extends { displayOrder?: number }>(left: T, right: T) {
  return (
    (left.displayOrder ?? Number.MAX_SAFE_INTEGER) - (right.displayOrder ?? Number.MAX_SAFE_INTEGER)
  )
}

export function isFillInTheBlankQuestion(question: EnglishTestQuestionDto) {
  return question.questionType === EnglishTestQuestionDtoQuestionTypeEnum.FillInBlank
}

export function isDateEntryQuestion(question: EnglishTestQuestionDto) {
  return (question.questionType as string | undefined) === DATE_ENTRY_QUESTION_TYPE
}

export function isPlainTextEntryQuestion(question: EnglishTestQuestionDto) {
  return (question.questionType as string | undefined) === TEXT_ENTRY_QUESTION_TYPE
}

export function isTextEntryQuestion(question: EnglishTestQuestionDto) {
  return (
    isFillInTheBlankQuestion(question) ||
    isDateEntryQuestion(question) ||
    isPlainTextEntryQuestion(question)
  )
}

export function hasAnsweredQuestion(answer: QuestionAnswerValue) {
  if (!answer) {
    return false
  }

  if (answer.type === 'text') {
    return answer.value.trim().length > 0
  }

  return answer.optionIndex >= 0
}

export function resolveQuestionImageUrl(imageUrl?: string) {
  if (!imageUrl) {
    return null
  }

  if (/^(https?:|data:|blob:)/i.test(imageUrl)) {
    return imageUrl
  }

  return new URL(imageUrl, API_URL).toString()
}
